var interval = setInterval(function() {
  var hpBadge = document.querySelector('.hp-badge');
  if (!hpBadge) {
    return;
  }

  var bottomLeft = hpBadge.closest('.shg-box-vertical-align-wrapper');
  if (!bottomLeft) {
    return;
  }

  clearInterval(interval);
  bottomLeft.classList.add('bottom-left');
  hpBadge.setAttribute('style', 'display: inline-block !important');
}, 250);

let params = new URLSearchParams(window.location.search);
let openTab = params.get('open');
if(openTab === 'tips') {
  let tips = document.getElementsByClassName('tips-accordion')[0];
  if(tips) {
    let accordion = tips.parentNode;
    console.log(accordion);
    if(accordion) {
      accordion.classList.add('shogun-accordion-active');
      accordion.parentNode.classList.add('shogun-accordion-active');
    }
  }
}
